import React from 'react'
import { connect } from 'react-redux'
import PendingApprovalProfilesList from './PendingApprovalProfilesList'
import { actions } from './pendingApprovalAdviserProfilesContainerActions'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types';

class PendingApprovalProfilesListContainer extends React.Component {
  static propTypes = {
    profiles: PropTypes.array.isRequired,
    fetchPendingApprovalProfiles: PropTypes.func.isRequired,
    fetchingPendingApprovalprofiles: PropTypes.bool.isRequired,
    searchTerm: PropTypes.string,
    filter: PropTypes.string.isRequired,
    filterChange: PropTypes.bool.isRequired,
    setSearchTerm: PropTypes.func.isRequired,
    setFilter: PropTypes.func.isRequired,
    currentPage: PropTypes.number.isRequired,
    currentPageChange: PropTypes.bool.isRequired,
    setPage: PropTypes.func.isRequired,
    pageSize: PropTypes.number.isRequired,
    numPages: PropTypes.number.isRequired
  }

  constructor (props) {
    super(props)
    this.fetchProfiles = this.fetchProfiles.bind(this)
    this.orderBy = this.orderBy.bind(this)

    this.state = {
      orderingBy: 'status',
      sortAscending: false
    }
  }

  componentDidUpdate(prevProps) {
    if ((!prevProps.filterChange && this.props.filterChange) || (!prevProps.currentPageChange && this.props.currentPageChange)) {
      this.fetchProfiles(this.props.searchTerm, this.props.currentPage, this.props.filter)
    }
  }

  componentDidMount () {
    // Reset to page 1 on entry: currentPage persists in the Redux slice, so returning after paging
    // to page 3 would otherwise request an out-of-range page (empty list). The search term is left
    // as-is on purpose - remembering it across navigation is fine, and every search resets to page 1
    // via onSearch, so search + paging stay consistent.
    this.props.setPage(1)
  }

  fetchProfiles (searchTerm, page, filter, orderingBy, sortAscending) {
    if (orderingBy === undefined) {
      orderingBy = this.state.orderingBy
    }
    if (sortAscending === undefined) {
      sortAscending = this.state.sortAscending
    }
    searchTerm = searchTerm || this.props.searchTerm
    page = page || this.props.currentPage
    filter = filter || this.props.filter
    const { pageSize, fetchPendingApprovalProfiles } = this.props
    filter = filter || 'pendingApproval'

    fetchPendingApprovalProfiles(searchTerm, page, pageSize, filter, orderingBy, sortAscending)
  }

  orderBy (column) {
    var sortAscending = false
    if (column === this.state.orderingBy) {
      sortAscending = !this.state.sortAscending
    }
    this.setState({
      orderingBy: column,
      sortAscending: sortAscending
    })
    this.fetchProfiles(null, null, null, column, sortAscending)
  }

  render () {
    const { setSearchTerm, searchTerm, filter, setFilter, fetchingPendingApprovalprofiles, profiles,
      currentPage, setPage, numPages } = this.props
    return <PendingApprovalProfilesList
      sortAscending={this.state.sortAscending}
      orderingBy={this.state.orderingBy}
      orderBy={this.orderBy}
      setSearchTerm={setSearchTerm}
      searchTerm={searchTerm}
      filter={filter}
      setFilter={setFilter}
      fetchProfiles={this.fetchProfiles}
      fetchingProfiles={fetchingPendingApprovalprofiles}
      profiles={profiles}
      currentPage={currentPage}
      setPage={setPage}
      numPages={numPages} />
  }
}

const mapStateToProps = ({ pendingApprovalAdviserProfiles }) => {
  return {
    profiles: pendingApprovalAdviserProfiles.pendingApprovalAdviserProfiles,
    fetchingPendingApprovalprofiles: pendingApprovalAdviserProfiles.fetchingPendingApprovalProfiles,
    searchTerm: pendingApprovalAdviserProfiles.searchTerm,
    filter: pendingApprovalAdviserProfiles.filter,
    filterChange: pendingApprovalAdviserProfiles.filterChange,
    currentPage: pendingApprovalAdviserProfiles.currentPage,
    currentPageChange: pendingApprovalAdviserProfiles.currentPageChange,
    pageSize: pendingApprovalAdviserProfiles.pageSize,
    numPages: pendingApprovalAdviserProfiles.numPages
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    fetchPendingApprovalProfiles: actions.fetch.pendingApprovalProfiles,
    setSearchTerm: actions.set.searchTerm,
    setFilter: actions.set.filter,
    setPage: actions.set.page
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PendingApprovalProfilesListContainer)
